import React, { memo, useCallback } from 'react';
import { CredentialResponse, GoogleLogin } from '@react-oauth/google';

import './GoogleButton.css';
import { useGoogleSignInMutation } from '../../apis/mlkApi/mlk.api.hooks';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { getOperationSelector } from '../../redux/general/general.selectors';
import { parseRes } from '../../apis/utils';
import { handleSignIn } from '../../helpers/auth';

type GoogleButtonProps = {};

export const GoogleButton: React.FC<GoogleButtonProps> = memo(() => {
  const history = useHistory();
  const [googleSignIn] = useGoogleSignInMutation();
  const operation = useSelector(getOperationSelector);

  const onSignInSuccess = useCallback(
    (response: CredentialResponse) => {
      if (response.credential !== undefined) {
        googleSignIn({ idToken: response.credential }).then((res) => {
          const { successRes, errorRes } = parseRes(res);
          handleSignIn(successRes, operation, history);
          if (errorRes.error) {
            // TODO: Handle error
          }
        });
      }
    },
    [googleSignIn, history, operation]
  );

  const onSignInFailure = useCallback(() => {
    // TODO: Handle login failure
  }, []);

  return (
    <div className="google-button--button-container">
      <GoogleLogin
        locale="it"
        size="large"
        shape="circle"
        onSuccess={onSignInSuccess}
        onError={onSignInFailure}
      />
    </div>
  );
});
